import React from 'react';
import PublicNavbar from '../components/layout/PublicNavbar';
import { FiMail, FiPhone, FiMapPin, FiSend } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import '../styles/Contact.css';

const Contact = () => {
    const { isAuthenticated } = useAuth();

    return (
        <>
            {!isAuthenticated && <PublicNavbar />}
            <div className="contact-page" style={{ paddingTop: isAuthenticated ? '20px' : '80px' }}>
                <div className="contact-container">

                    <div className="contact-header">
                        <h1 className="contact-title">Conversemos</h1>
                        <p className="contact-subtitle">Contáctanos para solicitar una demostración, armar tu pack de suite personalizado o resolver cualquier duda.</p>
                    </div>

                    <div className="row">
                        {/* Info Column */}
                        <div className="col-md-5 mb-4 mb-md-0">
                            <div className="contact-info-card">
                                <h3 className="contact-info-title">Información de Contacto</h3>

                                <ul className="contact-info-list">
                                    <li className="contact-info-item">
                                        <FiMail size={24} className="contact-info-icon email" />
                                        <div>
                                            <strong className="contact-info-label">Email</strong>
                                            <a href="mailto:ventas@idevplus.cl" className="contact-info-text">ventas@idevplus.cl</a>
                                        </div>
                                    </li>
                                    <li className="contact-info-item">
                                        <FiPhone size={24} className="contact-info-icon phone" />
                                        <div>
                                            <strong className="contact-info-label">Teléfono / WhatsApp</strong>
                                            <a href="tel:+56912345678" className="contact-info-text">+56 9 1234 5678</a>
                                        </div>
                                    </li>
                                    <li className="contact-info-item">
                                        <FiMapPin size={24} className="contact-info-icon location" />
                                        <div>
                                            <strong className="contact-info-label">Ubicación</strong>
                                            <span className="contact-info-text">Santiago, Chile</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Form Column */}
                        <div className="col-md-7">
                            <div className="contact-form-card">
                                <h3 className="contact-form-title">Envíanos un mensaje</h3>

                                <form onSubmit={(e) => { e.preventDefault(); alert('Formulario enviado (Demo). Un agente de IdevPlus te contactará pronto.'); }}>
                                    <div className="mb-3">
                                        <label className="form-label contact-form-label">Nombre Completo</label>
                                        <input type="text" className="form-control contact-form-input" placeholder="Juan Pérez" required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label contact-form-label">Correo Electrónico</label>
                                        <input type="email" className="form-control contact-form-input" placeholder="juan@empresa.com" required />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label contact-form-label">Motivo del Contacto</label>
                                        <select className="form-select contact-form-input" required>
                                            <option value="">Selecciona una opción...</option>
                                            <option value="pack">Cotizar un Pack de Suite</option>
                                            <option value="demo">Solicitar Demo Personalizada</option>
                                            <option value="dudas">Dudas sobre planes</option>
                                            <option value="otro">Otro</option>
                                        </select>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label contact-form-label">Mensaje</label>
                                        <textarea className="form-control contact-form-input" rows="4" placeholder="¿En qué podemos ayudarte?" required></textarea>
                                    </div>

                                    <button type="submit" className="btn-action w-100 contact-submit-btn">
                                        <FiSend /> Enviar Mensaje
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Contact;
